import React, { Component } from 'react';
import styled from 'styled-components'
import Layout from '../components/layout';
import SEO from '../components/seo';
import NewsItem from '../components/news-item';
import { colors } from '../style/colors';
import { navWidth } from '../components/reusables';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: calc(100vw - ${navWidth});
    margin: 0 auto;
    margin-top: 170px;
    padding: 0 50px;
    position: relative;

    @media (max-width: 768px) {
      padding: 20px;
      max-width: none;
    }

    @media (max-width: 550px) {
    margin-top: 90px;
}
`
const Title = styled.h1`
  text-align: left;
  width: 100%;
  font-family: 'expo-serif-pro';

  color: ${colors.main};

  @media (max-width: 768px) {
      padding: 0;
    }
`;
const NewsGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  @media (max-width: 768px) {
      padding: 0;
    }
`;
class NewsPage extends Component {
  state = {}
  render() {
    const posts = this.props.data.newsPosts.edges
    return (
      <Layout>
        <SEO title="News" />
        <Container>
          <Title>News</Title>
          <NewsGrid>
            {posts.map((newsItem, index) => (
              <NewsItem key={index} slug={newsItem.node.slug} title={newsItem.node.title} cover={newsItem.node.featured_media.source_url} fluid={newsItem.node.featured_media.localFile.childImageSharp.fluid} date={newsItem.node.date} />
            ))}
          </NewsGrid>
        </Container>
      </Layout>
    );
  }
}

export default NewsPage;

export const newsQuery = graphql`
  query($news: String = "News") {
    newsPosts: allWordpressPost(
      filter: { categories: { elemMatch: { name: { eq: $news } } } }
      sort: { fields: date, order: DESC }
    ) {
      edges {
        node {
          slug
          title
          date
          excerpt
          featured_media {
              source_url
              localFile {
              childImageSharp {
                fluid(maxHeight: 500) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`